// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/register-request-schema',
  type: 'object',
  required: ['email', 'userName', 'password'],
  properties: {
    email: {
      type: 'string',
      format: 'email',
      minLength: 1,
    },
    userName: {
      type: 'string',
      minLength: 2,
    },
    password: {
      type: 'string',
      minLength: 6,
    },
    userLanguage: {
      type: 'string',
      nullable: true,
      maxLength: 2,
    },
    userCulture: {
      type: 'string',
      nullable: true,
    },
    isGdprConsentAccepted: {
      type: 'boolean',
    },
    registrationKey: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
